module.exports = __webpack_public_path__ + "img/booking-cargo.8a76bb9c.svg";